import { render, staticRenderFns } from "./message-list-item.vue?vue&type=template&id=40385f61&"
import script from "./message-list-item.vue?vue&type=script&lang=js&"
export * from "./message-list-item.vue?vue&type=script&lang=js&"
import style0 from "./message-list-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports